import {
    mdiAlertCircleOutline,
    mdiCancel,
    mdiCheckCircleOutline,
    mdiClockOutline,
    mdiLanDisconnect,
    mdiProgressClock,
    mdiTimerAlertOutline,
    mdiTimerSandComplete,
} from '@mdi/js'
import type { AgentRun } from '../../api/schema'

/** The status a run is shown with: the server's, plus `cancelling`. */
export type AgentRunDisplayStatus = AgentRun['status'] | 'cancelling'

export type StatusTone = 'success' | 'warning' | 'destructive' | 'info' | 'muted'

/**
 * One config map for every place a run's status shows (pattern 15): tone,
 * MDI icon, label key in the agent-runs namespace.
 */
export const AGENT_RUN_STATUS: Record<AgentRunDisplayStatus, { tone: StatusTone; icon: string; labelKey: string }> = {
    queued: { tone: 'muted', icon: mdiClockOutline, labelKey: 'status.queued' },
    running: { tone: 'info', icon: mdiProgressClock, labelKey: 'status.running' },
    cancelling: { tone: 'warning', icon: mdiTimerSandComplete, labelKey: 'status.cancelling' },
    succeeded: { tone: 'success', icon: mdiCheckCircleOutline, labelKey: 'status.succeeded' },
    failed: { tone: 'destructive', icon: mdiAlertCircleOutline, labelKey: 'status.failed' },
    cancelled: { tone: 'muted', icon: mdiCancel, labelKey: 'status.cancelled' },
    timed_out: { tone: 'warning', icon: mdiTimerAlertOutline, labelKey: 'status.timed_out' },
    interrupted: { tone: 'warning', icon: mdiLanDisconnect, labelKey: 'status.interrupted' },
}

/** displayStatus: a running run with a cancel reason reads `cancelling`. */
export function displayStatus(run: Pick<AgentRun, 'status' | 'cancel_reason'>): AgentRunDisplayStatus {
    if (run.status === 'running' && run.cancel_reason) return 'cancelling'
    return run.status
}

/** The Badge variant of a tone. */
export function toneVariant(tone: StatusTone): 'success' | 'warning' | 'destructive' | 'info' | 'secondary' {
    return tone === 'muted' ? 'secondary' : tone
}
